import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import {
  CheckboxFieldReduxFormWrapper,
  InputFieldReduxFormWrapper,
  SelectFieldReduxFormWrapper,
  Grid,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { BEDS_OPTIONS, BATHS_OPTIONS } from '../../../constants/filters'
import styles from './styles.scss'
const cx = classnames.bind(styles)
const { Row, Column } = Grid

class PropertyFiltersContent extends Component {
  static propTypes = {
    className: PropTypes.string,
    elmId: PropTypes.string.isRequired,
    submitForms: PropTypes.func.isRequired,
  }

  onChange = (e, curValue, prevValue) => {
    curValue !== prevValue && this.props.submitForms()
  }

  // this function is called from redux form normalize
  sqftNormalize = (value, previousValue) => {
    return value ? value.replace(/[^\d]/g, '') : ''
  }

  render() {
    const { elmId, className, submitForms } = this.props
    return (
      <section data-elm-id={elmId} className={className}>
        <Grid>
          <Row className={cx('u-mt-1')}>
            <Column width={8} style={{ marginBottom: 14 }}>
              <Field
                name='beds'
                label='Beds'
                elmId={`${elmId}_beds`}
                options={BEDS_OPTIONS}
                onChange={this.onChange}
                className={cx('filter-input-label')}
                component={SelectFieldReduxFormWrapper}
              />
            </Column>
            <Column width={8}>
              <Field
                name='baths'
                label='Baths'
                elmId={`${elmId}_baths`}
                options={BATHS_OPTIONS}
                onChange={this.onChange}
                className={cx('filter-input-label')}
                component={SelectFieldReduxFormWrapper}
              />
            </Column>
          </Row>
          <label className={cx('filter-section-label')}>Square Feet</label>
          <Row style={{ paddingTop: 0 }}>
            <Column width={8}>
              <Field
                name='sqft_min'
                placeholder='Min'
                elmId={`${elmId}_sqft_min`}
                onChange={this.onChange}
                normalize={this.sqftNormalize}
                component={InputFieldReduxFormWrapper}
              />
            </Column>
            <Column width={8}>
              <Field
                name='sqft_max'
                placeholder='Max'
                elmId={`${elmId}_sqft_max`}
                onChange={this.onChange}
                normalize={this.sqftNormalize}
                component={InputFieldReduxFormWrapper}
              />
            </Column>
          </Row>

          <label className={cx('filter-section-label')}>Type</label>
          <Row style={{ paddingTop: 8 }}>
            <Column mobile={16}>
              <Field
                compact
                type='checkbox'
                name='single_family'
                elmId={`${elmId}_single_family`}
                onChange={submitForms}
                label='Single Family'
                component={CheckboxFieldReduxFormWrapper}
              />

              <Field
                compact
                type='checkbox'
                name='condos_townhouses'
                elmId={`${elmId}_condos_townhouses`}
                onChange={submitForms}
                label='Condo, Townhome, other single unit'
                component={CheckboxFieldReduxFormWrapper}
                className={cx('condo-townhouse-label')}
              />

              <Field
                compact
                type='checkbox'
                name='multi_family'
                elmId={`${elmId}_multi_family`}
                onChange={submitForms}
                label='Multi-family'
                component={CheckboxFieldReduxFormWrapper}
              />

              <Field
                compact
                type='checkbox'
                name='land'
                elmId={`${elmId}_land`}
                onChange={submitForms}
                label='Land'
                component={CheckboxFieldReduxFormWrapper}
              />
            </Column>
          </Row>
        </Grid>
      </section>
    )
  }
}

export default PropertyFiltersContent
